import { CeruleanWaveform } from './waveform';

document.addEventListener('DOMContentLoaded', () => {
  const canvas = document.getElementById('waveform-canvas') as HTMLCanvasElement;
  if (!canvas) {
    console.error('Waveform canvas not found');
    return;
  }

  // Initialize calm cerulean waveform
  const waveform = new CeruleanWaveform({ canvas });

  // Clean teardown if needed
  window.addEventListener('beforeunload', () => {
    waveform.stop();
  });
});
